import React, { useState, Dispatch, SetStateAction } from "react";
import { PartyInfoFilterContainer } from "../../PartyInfo/PartyInfoFilter";
import Flex from "../../../../DefaultStyles/Flex";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import CalendarModal from "../../../../Modal/CalendarModal";
import { CalendarLine } from "../../ChatInfo/Old/OldRecentChat";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";

interface UplusDataUploadInfoFilterProps {
  pageResetEvent: () => void;
  setFilter: Dispatch<SetStateAction<{ startdate: string; enddate: string }>>;
}

export default function UplusDataUploadInfoFilter({
  pageResetEvent,
  setFilter,
}: UplusDataUploadInfoFilterProps) {
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <PartyInfoFilterContainer maxWidth={1200}>
      <div />

      <Flex gapSize={10}>
        <FilterIcon maxWidth={1200} />

        {/* 신청일 날짜 선택 */}

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setStartDateClick(true)}
            value={startDate}
            initValue={"날짜 선택"}
            minWidth={155}
          />

          {startDateClick && (
            <CalendarModal
              closeEvent={() => setStartDateClick(false)}
              changeEvent={(date: string) => setStartDate(date)}
              isFutureDisable={true}
            />
          )}
        </LineBoxContainer>

        <CalendarLine />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setEndDateClick(true)}
            value={endDate}
            initValue={"날짜 선택"}
            minWidth={155}
            disabled={startDate?.includes("선택")}
          />

          {endDateClick && (
            <CalendarModal
              closeEvent={() => setEndDateClick(false)}
              changeEvent={(date: string) => setEndDate(date)}
              dateValue={startDate}
              isAfterStartDate={true}
            />
          )}
        </LineBoxContainer>

        <ConfirmBtn
          btnText="적용"
          btnColor="mint"
          btnHeight={38}
          isDisabled={startDate?.includes("선택") || endDate?.includes("선택")}
          btnClickEvent={() => {
            pageResetEvent();
            setFilter((prev) => ({
              ...prev,
              startdate: startDate,
              enddate: endDate,
            }));
          }}
        />

        <LineBtn
          btnText="초기화"
          btnColor="mint"
          icon="refresh"
          btnHeight={38}
          disabled={startDate?.includes("선택") && endDate?.includes("선택")}
          btnClickEvent={() => {
            setStartDate("날짜 선택");
            setEndDate("날짜 선택");

            setFilter({
              startdate: "",
              enddate: "",
            });
          }}
        />
      </Flex>
    </PartyInfoFilterContainer>
  );
}
